import type { Role } from '@/contracts/wire';

/**
 * Who is signed in and which company they work in (WEB_PLAN.md §3.1). Built by auth/ from the Supabase session and
 * `my_memberships`; read by sync/, domain/ and every screen through `useSession()`.
 */
export interface SessionCtx {
  authUserId: string;
  /** The account's email (or null for a phone-only or Apple private-relay account without one). */
  email: string | null;
  /** Lower-case company id. */
  companyId: string;
  companyName: string;
  /** The `users` item that is "me" (as the server returned it; compare with sameId). */
  profileId: string;
  role: Role;
}

/** Role gates as the iOS UI uses them (WEB_PLAN.md §5.0): admin = admin; manager = admin or manager. */
export function isAdmin(ctx: Pick<SessionCtx, 'role'>): boolean {
  return ctx.role === 'admin';
}

export function isManager(ctx: Pick<SessionCtx, 'role'>): boolean {
  return ctx.role !== 'rep';
}
